module.exports = __webpack_public_path__ + "static/img/6.ff851543.png";